module.exports = __webpack_public_path__ + "static/australien-c6d3564027e8a4081fb146fd7b46b941.svg";